var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconCheckoutPayment = function SvgIconCheckoutPayment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41.749,
    height: 33.057,
    viewBox: "0 0 41.749 33.057",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1227",
    "data-name": "Group 1227",
    transform: "translate(-804.47 -422.467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1194",
    "data-name": "Group 1194",
    transform: "translate(813.528 435.837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2514",
    "data-name": "Path 2514",
    d: "M264.929,317.1v-11a.757.757,0,0,1,.757-.757h25.985",
    transform: "translate(-264.929 -305.343)",
    fill: "none",
    stroke: "#042e5a",
    strokeMiterlimit: 10,
    strokeWidth: 1.058
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2515",
    "data-name": "Path 2515",
    d: "M264.929,317.1v6.643a.757.757,0,0,0,.757.757h30.648a.757.757,0,0,0,.757-.757V306.1a.757.757,0,0,0-.757-.757h-4.663",
    transform: "translate(-264.929 -305.343)",
    fill: "none",
    stroke: "#042e5a",
    strokeMiterlimit: 10,
    strokeWidth: 1.058
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_663",
    "data-name": "Rectangle 663",
    width: 32.162,
    height: 2.947,
    transform: "translate(0 5.878)",
    fill: "#042e5a"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_245",
    "data-name": "Line 245",
    x2: 13.384,
    transform: "translate(2.698 12.672)",
    fill: "none",
    stroke: "#042e5a",
    strokeMiterlimit: 10,
    strokeWidth: 1.058
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_246",
    "data-name": "Line 246",
    x2: 13.384,
    transform: "translate(2.698 15.708)",
    fill: "none",
    stroke: "#042e5a",
    strokeMiterlimit: 10,
    strokeWidth: 1.058
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1195",
    "data-name": "Group 1195",
    transform: "translate(805 423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2516",
    "data-name": "Path 2516",
    d: "M285.663,297.377l-.856-9.651a.759.759,0,0,0-.822-.688l-30.527,2.709a.757.757,0,0,0-.688.821l1.559,17.574a.758.758,0,0,0,.821.688l4.645-.412",
    transform: "translate(-252.767 -287.035)",
    fill: "none",
    stroke: "#042e5a",
    strokeMiterlimit: 10,
    strokeWidth: 1.058
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_664",
    "data-name": "Rectangle 664",
    width: 32.162,
    height: 2.947,
    transform: "translate(32.718 8.338) rotate(174.93)",
    fill: "#042e5a"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_247",
    "data-name": "Line 247",
    y1: 0.413,
    x2: 4.656,
    transform: "translate(2.848 13.923)",
    fill: "none",
    stroke: "#042e5a",
    strokeMiterlimit: 10,
    strokeWidth: 1.058
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_248",
    "data-name": "Line 248",
    y1: 0.367,
    x2: 4.139,
    transform: "translate(3.178 17.685)",
    fill: "none",
    stroke: "#042e5a",
    strokeMiterlimit: 10,
    strokeWidth: 1.058
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCheckoutPayment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_checkout_payment.fb26c785.svg";
export { ForwardRef as ReactComponent };